// import { useLogContext } from '../context/logContext';
// let appMode = 'debug';
// let doLogError = true;

import df from '../utils/DateFormat';
import { publish } from '../utils/pubsub';

let _logCtx = null;

class LogService {
    initialize = (logCtx) => {
        if (_logCtx !== null) return;
        _logCtx = logCtx;
    };

    log = (msg) => {
        const doLog = _logCtx === null ? true : _logCtx.doLogMessage;
        if (!doLog) {
            return;
        }

        const s = this.getTime();
        console.log(`${s}: ${msg}`);
        return;
    };

    logError = (msg) => {
        const s = this.getTime();
        const logMsg = `${s}: ${msg}`;
        publish(`Logger_ErrorHappend`, logMsg);

        const doLog = _logCtx === null ? true : _logCtx.doLogError;
        if (!doLog) {
            return;
        }

        console.log(logMsg);
        return;
    };

    getTime = () => {
        const date = Date.now();
        const s = df.epochToDateStr(date / 1000, 'yyyymmdd HH:MM:ss');

        return s;
    };
}

const logService = new LogService();
export default logService;
